import { SpacingOptions } from '@material-ui/core/styles/createSpacing';

// Note! use material-ui default (8px)
// see globals.ts for specific material-ui theme overrides
// and see styling per specific custom component
const spacing: SpacingOptions = 8;

export default spacing;